var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('v-row',[_c('div',{staticClass:"titulo2"},[_c('h1',[_vm._v("Mis Boletos")])]),_c('div',{staticClass:"back"},[_c('router-link',{attrs:{"to":"/cuenta"}},[_c('button',[_c('Back')],1)])],1)]),_vm._m(0)],1),_c('div',[_c('BoletoFactura')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub"},[_c('h2',[_vm._v("¿Estamos listos para viajar?")]),_c('br')])
}]

export { render, staticRenderFns }